<template>
  <layout-workflow>
    <template #subheader>
      <TermsHeader />
    </template>
    <template #default>
      <div class="ma-4">
        <app-pdf :file-url="'/terms.pdf'" />
      </div>
    </template>
  </layout-workflow>
</template>

<script>
import LayoutWorkflow from '@/components/layout/LayoutWorkflow'
import TermsHeader from '@/components/support/TermsHeader'

export default {
  components: { TermsHeader, LayoutWorkflow }
}
</script>
